/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTemplateSchema } from '../models/CreateTemplateSchema';
import type { TemplateListSchema } from '../models/TemplateListSchema';
import type { TemplateSchema } from '../models/TemplateSchema';
import type { UpdateTemplateSchema } from '../models/UpdateTemplateSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TemplatesApi {
    /**
     * Create Template
     * Create template. <br>Required Permission: create_template
     * @returns TemplateSchema Created
     * @throws ApiError
     */
    public static templatesCreateTemplatePost({
        requestBody,
    }: {
        requestBody: CreateTemplateSchema,
    }): CancelablePromise<TemplateSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/templates/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Template
     * Delete template. <br>Required Permission: remove_template
     * @returns any OK
     * @throws ApiError
     */
    public static templatesDeleteTemplateDelete({
        templateId,
    }: {
        templateId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/templates/',
            query: {
                'template_id': templateId,
            },
        });
    }
    /**
     * Get Template List
     * Get list of templates. <br>Required Permission: list_templates
     * @returns TemplateListSchema OK
     * @throws ApiError
     */
    public static templatesGetTemplateListGet(): CancelablePromise<Array<TemplateListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/templates/',
        });
    }
    /**
     * Update Template
     * Update a template. <br>Required Permission: update_template
     * @returns TemplateSchema OK
     * @throws ApiError
     */
    public static templatesUpdateTemplatePut({
        templateId,
        requestBody,
    }: {
        templateId: string,
        requestBody: UpdateTemplateSchema,
    }): CancelablePromise<TemplateSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/templates/',
            query: {
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Template
     * Get a template. <br>Required Permission: get_template_detail
     * @returns TemplateSchema OK
     * @throws ApiError
     */
    public static templatesGetTemplateGet({
        templateId,
    }: {
        templateId: string,
    }): CancelablePromise<TemplateSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/templates/{template_id}/',
            path: {
                'template_id': templateId,
            },
        });
    }
}
